import React from 'react';

import gogglesSideView from '../../../main/assets/images/fpvonepilot/gogglesSideView.webp';

export const Measurements = () => {
  return (
    <section className="fpv-pilot-measurements-section">
      <div className="fpv-pilot-measurements-titles">
        <h3 className="fpv-pilot-measurements-subtitle">Measurements</h3>
        <h2 className="fpv-pilot-measurements-title">Perfectly fitted</h2>
      </div>

      <div className="fpv-pilot-measurements-second-row">
        <div className="fpv-pilot-measurements-specs">
          <div className="fpv-pilot-measurements-spec">
            <h3 className="fpv-pilot-measurements-spec-title">Weight</h3>
            <p className="fpv-pilot-measurements-spec-description">256g</p>
          </div>
          <div className="fpv-pilot-measurements-spec">
            <h3 className="fpv-pilot-measurements-spec-title">Dimensions</h3>
            <p className="fpv-pilot-measurements-spec-description">
              177 x 107 x 72mm
            </p>
          </div>
          <div className="fpv-pilot-measurements-spec">
            <h3 className="fpv-pilot-measurements-spec-title">IPD Range</h3>
            <p className="fpv-pilot-measurements-spec-description">56-74 mm</p>
          </div>
          <div className="fpv-pilot-measurements-spec">
            <h3 className="fpv-pilot-measurements-spec-title">
              Head Tracker Output
            </h3>
            <p className="fpv-pilot-measurements-spec-description">
              3.5mm jack
            </p>
          </div>
        </div>
        <div className="fpv-pilot-measurements-image">
          <img
            src={gogglesSideView}
            alt="The Equipment from the Side"
            className="fpv-pilot-measurements-product"
          />
        </div>
      </div>
    </section>
  );
};
